import { useLocation } from 'react-router-dom';

const useQueryParams = () => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  return queryParams;
};

export default useQueryParams;
